import React, { ComponentProps } from 'react';
import { PageTypeRole } from '../PageTypeRoles.types';
import { asFetchableView, useViewContext } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { ContentList, ContentListItem } from '../../../_lib/components/ContentList';
import { ContentHeadline } from '../../../_lib/components/ContentHeadline';
import { ContentParagraph } from '../../../_lib/components/ContentParagraph';
import { ContentHeadlineModifier } from '../../../_lib/components/ContentHeadline/ContentHeadline';

export type PageTypeRolesBlockDefaultViewProps = {
  roles: PageTypeRole[];
};

function PageTypeRolesDefaultView({ roles }: PageTypeRolesBlockDefaultViewProps) {
  const { t } = useSonTranslation('PageTypeRoles');

  const { additionalProps } = useViewContext();
  const { headingHierarchy } = additionalProps;

  if (!roles || roles.length === 0) {
    return <ContentMessage text={t('noContent')} />;
  }

  return (
    <ContentList ordered>
      {roles.map(role => (
        <ContentListItem key={role.id}>
          <ContentHeadline
            title={role.name}
            hierarchy={headingHierarchy}
            modifier={ContentHeadlineModifier.TOP_HEADLINE}
          />
          <ContentParagraph>{role.description}</ContentParagraph>
        </ContentListItem>
      ))}
    </ContentList>
  );
}

export const PageTypeRolesBlockDefaultView = asFetchableView(PageTypeRolesDefaultView);
export type PageTypeRolesBlockDefaultView = ComponentProps<typeof PageTypeRolesBlockDefaultView>;
